import { styled } from '@mui/material/styles';

export const CloseButton = styled('button')(({ theme }) => ({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  color: theme.color.grey[500],
  display: 'flex',
  marginRight: theme.spacing(-0.5),
  padding: 0,
  '&:hover': {
    cursor: 'pointer'
  }
}));

export const Container = styled('div')(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.color.grey[500]}`,
  boxSizing: 'border-box',
  display: 'flex',
  height: '65px',
  justifyContent: 'space-between',
  margin: `0 ${theme.spacing(3)}`,
  padding: `${theme.spacing(3)} 0`
}));

export const Title = styled('span')(({ theme }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize.large,
  textTransform: 'uppercase'
}));

export const SubTitle = styled('span')(({ theme }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize.small,
  textTransform: 'none'
}));
